export default import.meta.ROLLDOWN_FILE_URL_6cKV9JT4d4QiFg63yGJpoQ